import { render, staticRenderFns } from "./LocalisationSidebar.vue?vue&type=template&id=de320106&"
import script from "./LocalisationSidebar.vue?vue&type=script&lang=js&"
export * from "./LocalisationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CurrencyButton: require('/opt/build/repo/storefront/components/molecules/Button/CurrencyButton.vue').default,BaseSidebar: require('/opt/build/repo/storefront/components/molecules/Sidebar/BaseSidebar.vue').default})
